import { useState, useEffect } from 'react';
import { motion } from "framer-motion"

import './MapStyleControlPanel.css';
import classNames from 'classnames';
import { useAtomValue, useSetAtom } from 'jotai';
import { bgMapSourcesAtom, isDesktopAtom } from '../../atoms';

import { BsFillLayersFill } from "react-icons/bs";

import mapStyleConfig from '../../assets/mapStyleConfig.json';
import { MapStyleConfigType } from '../../types/components/mapStyleConfig';

import { MapStyleControlPanelPropsType } from '../../types/components/mapStyleController';


const MapStyleControlPanel: React.FC<MapStyleControlPanelPropsType> =  ({ selectedBaseMap, setSelectedBaseMap, position }) => {

  const [open, setOpen] = useState(false);
  const isDesktop = useAtomValue(isDesktopAtom);
  const setBgMapSourceNames = useSetAtom(bgMapSourcesAtom);


  /* ******************
   * レイヤーを切り替える
   * ******************/
  const changeLayer = (style: MapStyleConfigType) => {
    setSelectedBaseMap(style);
    setOpen(false);
  }

  /* ******************
   * 背景地図のソース名を取得
   * ******************/
  useEffect(() => {
    setBgMapSourceNames(mapStyleConfig.flat());
  }, []);


  if(!mapStyleConfig) { return <></>; }

  return (
    <>
      <motion.div 
        className={classNames('layer-select-area', {'left': position === 'left', 'right': position !== 'left'})} 
        initial={isDesktop ? { bottom: 100, height: 0, opacity: 0 } : { bottom: 40, height: 0, opacity: 0 }}
        animate={isDesktop ? 
          (open ? { bottom: 132, height: 'auto', opacity: 1 } : { bottom: 100, height: 0, opacity: 0 })
          :
          (open ? { bottom: 94, height: 'auto', opacity: 1 } : { bottom: 40, height: 0, opacity: 0 })
        }
        transition={{ duration: 0.2 }}
      >
        { mapStyleConfig && mapStyleConfig.map((style) => {
            const itemClass = {
              'selected': selectedBaseMap && selectedBaseMap.id === style.id
            }
            return (
              <div className={ classNames('item', itemClass) } onClick={() => changeLayer(style)} key={style.label}>
                <div className='imageWrapper' >
                  <img src={`${location.protocol}//${location.host}${location.pathname}${style.previewImgUrl}`} alt={`${style.label}画像`} width="40" height="40" />
                </div>
                <p className='label'>
                  {style.label}
                </p>
              </div>
            );
        })}
      </motion.div>
      <div className={classNames('map-style-controller', {'left': position === 'left', 'right': position !== 'left'})} onClick={() => setOpen(!open)}>
        <div className='icon'>
          <BsFillLayersFill/>
        </div>
        { !isDesktop && <p className='label'>背景地図</p> }
        <div className='inner'>
          <img src={selectedBaseMap?.previewImgUrl} alt={ selectedBaseMap?.label } className='icon'width="40" height="40" />
          <p className='label'>背景地図選択</p>
        </div>
      </div>
    </>
  );
};

export default MapStyleControlPanel;
